<template>
  <v-text-field
    :label="label"
    :clearable="clearable"
    :hide-details="hideDetails"
    :prepend-inner-icon="prependInnerIcon"
    :dark="dark"
    :solo-inverted="soloInverted"
    :flat="flat"
    v-bind="$attrs"
    v-on="listeners"
    :class="{ small: small }"
    @input="onInput"
    :value="value"
  ></v-text-field>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  props: {
    value: {
      default: undefined
    },
    label: {
      type: String,
      default () {
        return this.$t('common.search')
      }
    },
    clearable: {
      type: Boolean,
      default: true
    },
    hideDetails: {
      type: Boolean,
      default: true
    },
    prependInnerIcon: {
      type: String,
      default: 'search'
    },
    dark: {
      type: Boolean,
      default: true
    },
    soloInverted: {
      type: Boolean,
      default: true
    },
    flat: {
      type: Boolean,
      default: true
    },
    small: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    listeners () {
      let { input, ...listeners } = this.$listeners
      return listeners
    }
  },
  methods: {
    emitValue (v) {
      this.$emit('input', v)
    },
    onInput: debounce(function (e) { this.emitValue(e) }, 500)
  }
}
</script>

<style>

</style>
